exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drag-and-drop-item {\n  color: #767676;\n  margin-top: 3px;\n  overflow: hidden;\n  padding: 10px;\n  padding-right: 40px;\n  position: relative; }\n  .drag-and-drop-item:hover {\n    background-color: #d5ae73;\n    border-radius: 3px;\n    color: #ffffff; }\n  .drag-and-drop-item i {\n    position: absolute;\n    font-size: 26px;\n    right: 6px;\n    top: 6px; }\n\n/deep/ .drag-and-drop-user-error {\n  color: red !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /dist/src/app/shared/drag-and-drop/drag-and-drop.component.scss
// module id = ../../../../../src/app/shared/drag-and-drop/drag-and-drop.component.scss
// module chunks = main